import { BorderRadius, Color, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

interface StickyScrollbarContainerProps {
  isSticky?: boolean
}

export const StickyScrollbarContainer = styled.div<StickyScrollbarContainerProps>`
  width: 100%;
  height: 24px;
  position: sticky;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${zIndex.TableStickyHeader + 2};
  overflow-x: auto;
  overflow-y: hidden;

  ${({ isSticky }) =>
    isSticky &&
    `
    border-top: 1px solid ${Color.Grey150};
  `}

  /* Custom scrollbar styles for webkit browsers */
  &::-webkit-scrollbar {
    height: 23px;
  }

  &::-webkit-scrollbar-track {
    background: ${Color.Grey50};
  }

  &::-webkit-scrollbar-thumb {
    border: 8px solid ${Color.Grey50};
    border-radius: ${BorderRadius.R12};
    background: ${transparentize(0.6, Color.Grey500)};
    background-clip: content-box;
  }
`

interface ScrollbarTrackProps {
  width?: number
}

export const ScrollbarTrack = styled.div<ScrollbarTrackProps>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: 1px;
  pointer-events: none;
`
